import React from 'react';
import PropTypes from 'prop-types';
import Edit from 'react-icons/lib/md/edit';
import Trash from 'react-icons/lib/fa/trash';
import Upload from 'react-icons/lib/fa/upload';
import PhotoForm from './PhotoForm';
import Modal from 'react-bootstrap/lib/Modal';
import { get } from 'lodash';


class RoomPhotoUpload extends React.Component {
  constructor(props){
    super(props)
    this.state = {}
    this.handleClickPhoto = this.handleClickPhoto.bind(this)
    this.handleDestroyPhoto = this.handleDestroyPhoto.bind(this)
    this.loadingCell = this.loadingCell.bind(this)
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.photoList = this.photoList.bind(this);
  }

  handleClickPhoto(e, payload) {
    e.preventDefault();
    this.setState({
      showModal: true,
      editing: true,
      activePhoto: payload
    });
  }

  handleDestroyPhoto(e, payload) {
    e.preventDefault();
    this.props.onPhotoDestroySubmit({
      method: 'DELETE',
      form: {
        host_id: this.props.user.host.id,
        room_id: get(this.props, 'room.id', ''),
        authenticity_token: ReactOnRails.authenticityToken(),
        photo: {
          id: payload.id
        }
      }
    });
  }

  loadingCell() {
    return (
      <div className='col-md-3'>
         <i className="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      </div>
    )
  }

  photoList(){
    let _this=this;
    let list = [];
    if (this.props.photos && this.props.photos.length > 0){
      this.props.photos.forEach(function(photo){
        list.push(
          <li key={photo.id}>
            <div
              className='host-photo'
              style={{
                backgroundImage: photo.image ? `url("${photo.image.thumb}")` : '',
                width: 48,
                height: 48,
                backgroundRepeat: 'no-repeat'
              }}>
              <div className='photo-icons'>
                {
                  !_this.props.disablePhotoTitle &&
                  <a className='pull-left' href="#" onClick={(e) => _this.handleClickPhoto(e, photo)}><Edit/></a>
                }
                <a className='pull-left' href="#" onClick={(e) => _this.handleDestroyPhoto(e, photo)}><Trash/></a>
              </div>
            </div>
          </li>
        );
      });
    }
    const newPhoto = {
      id: '',
      name: '',
      image: {
        thumb: '',
        small: '',
        medium: '',
        original: ''
      }
    }
    return(
      <div>
        <ul className="list-inline" style={{marginBottom: '0px'}}>
          {list}
        </ul>
        {(() => {
          if (this.props.photos && this.props.photos.length < 3){
            return(
              <i  className="fa fa-lg fa-image"
                  style={{cursor:'pointer'}}
                  onClick={(e) => _this.handleClickPhoto(e, newPhoto)}
                  />
            )
          }
        })()}

      </div>
    );
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  render(){
    const photo = this.state.activePhoto;
    return (
      <div>
        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{photo && photo.id ? 'Edit Photo' : 'New Photo'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

          <PhotoForm
            intl={this.props.intl}
            photo={photo}
            user={this.props.user}
            resident={this.props.resident}
            room={this.props.room}
            didInvalidate={this.props.didInvalidate}
            uploader={this.props.uploader}
            onPhotoFormSubmit={this.props.onPhotoFormSubmit}
            onClose={this.close} />

          </Modal.Body>
        </Modal>
        {this.photoList()}
      </div>
    )
  }
};

RoomPhotoUpload.propTypes = {
  photo: PropTypes.object
};

export default RoomPhotoUpload;
